import React from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';

const rateTypeLabel = { HOURLY: '/hr', DAILY: '/day', WEEKLY: '/wk', MONTHLY: '/mo', FIXED: ' fixed' };
const statusColor   = { ACTIVE: 'chip-green', HIRED: 'chip-blue', PAUSED: 'chip-amber', CLOSED: 'chip-gray' };

export default function SeekAdCard({ ad, onHire, onContact, showActions = true }) {
  const { t, user } = useApp();

  const canHire    = user?.role === 'POSTER' && ad.status === 'ACTIVE' && !ad.isHired;
  const canContact = user?.role === 'POSTER';
  const isOwn      = user?.id === ad.seekerId;

  return (
    <div className="card seek-card fade-in" style={{ marginBottom: '10px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '12px' }}>
        {/* Left: info */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '6px', flexWrap: 'wrap' }}>
            {/* Avatar */}
            <div style={{
              width: 38, height: 38, borderRadius: '50%',
              background: 'var(--brand-light)', color: 'var(--brand-dark)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '15px', fontWeight: 700, flexShrink: 0,
            }}>
              {ad.seekerName?.[0]?.toUpperCase() ?? '?'}
            </div>
            <div>
              <Link to={`/seek-ads/${ad.id}`} style={{ fontWeight: 600, fontSize: '15px', color: 'var(--text)', textDecoration: 'none' }}>
                {ad.title}
              </Link>
              <div style={{ fontSize: '12px', color: 'var(--text3)' }}>{ad.seekerName}</div>
            </div>
          </div>

          <p style={{ fontSize: '13px', color: 'var(--text2)', marginBottom: '8px', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
            {ad.bio}
          </p>

          {/* Skills */}
          {ad.skills?.length > 0 && (
            <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap', marginBottom: '8px' }}>
              {ad.skills.slice(0, 5).map(s => (
                <span key={s} className="chip chip-gray" style={{ fontSize: '11px' }}>{s}</span>
              ))}
              {ad.skills.length > 5 && <span className="chip chip-gray" style={{ fontSize: '11px' }}>+{ad.skills.length - 5}</span>}
            </div>
          )}

          <div style={{ fontSize: '12px', color: 'var(--text3)', display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            <span>📍 {ad.location}</span>
            {ad.experience && <span>💼 {ad.experience}</span>}
            {ad.availability && <span>🕐 {ad.availability}</span>}
          </div>
        </div>

        {/* Right: rate + status */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '6px', flexShrink: 0 }}>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: '18px', fontWeight: 700, color: 'var(--brand)' }}>
              ৳{Number(ad.rate).toLocaleString()}
              <span style={{ fontSize: '12px', fontWeight: 400, color: 'var(--text3)' }}>
                {rateTypeLabel[ad.rateType] ?? ''}
              </span>
            </div>
            <div style={{ fontSize: '11px', color: 'var(--text3)' }}>{ad.category}</div>
          </div>
          <span className={`chip ${statusColor[ad.status] ?? 'chip-gray'}`}>
            {ad.isHired ? t('hired') : ad.status}
          </span>
        </div>
      </div>

      {/* Actions */}
      {showActions && (
        <div style={{ marginTop: '12px', display: 'flex', gap: '8px', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
          <Link to={`/seek-ads/${ad.id}`} className="btn btn-outline btn-sm">View profile</Link>
          {canContact && !isOwn && (
            <button className="btn btn-outline btn-sm" onClick={() => onContact?.(ad)}>
              🔒 {t('view_contact')} (−2)
            </button>
          )}
          {canHire && !isOwn && (
            <button className="btn btn-primary btn-sm" onClick={() => onHire?.(ad)}>
              {t('send_hire_request')}
            </button>
          )}
          {isOwn && (
            <Link to="/dashboard?tab=seek" className="btn btn-outline btn-sm">Manage</Link>
          )}
        </div>
      )}
    </div>
  );
}
